import { Component, inject, input } from '@angular/core';
import { I18nService } from '../../services/i18n.service';
import { NavButtonComponent } from '../nav-button/nav-button';
import { App_Routes } from '../../enums/router.enum';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-splash-screen',
  imports: [NavButtonComponent, NzIconModule],
  templateUrl: './splash-screen.html',
  styleUrls: ['./splash-screen.scss'],
})
export class SplashScreenComponent {
  readonly error = input<boolean>();
  refreshPage = `${App_Routes.FORWARD_SLASH}${App_Routes.HOME}`;
  public i18n = inject(I18nService);
}
